import { render } from "./quizPersonality.vue?vue&type=template&id=23a82670"
import script from "./quizPersonality.vue?vue&type=script&lang=js"
export * from "./quizPersonality.vue?vue&type=script&lang=js"

import "./quizPersonality.vue?vue&type=style&index=0&id=23a82670&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__